function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 69,
  height: 47,
  rx: 5.5,
  fill: "white",
  stroke: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35 19C35.8284 19 36.5 18.3284 36.5 17.5C36.5 16.6716 35.8284 16 35 16C34.1716 16 33.5 16.6716 33.5 17.5C33.5 18.3284 34.1716 19 35 19ZM35.8904 12.2947C35.361 11.9044 34.6392 11.9044 34.1098 12.2947L24.6107 19.2995C23.4455 20.1587 24.0533 22.0068 25.5009 22.0068H26V29.2491C24.8255 29.7389 24 30.898 24 32.25V33.75C24 34.1642 24.3358 34.5 24.75 34.5H45.25C45.6642 34.5 46 34.1642 46 33.75V32.25C46 30.898 45.1745 29.7389 44 29.2491V22.0068H44.4988C45.9465 22.0068 46.5542 20.1588 45.3891 19.2996L35.8904 12.2947ZM27.5 29V22.0068H30V29H27.5ZM42.5 22.0068V29H40V22.0068H42.5ZM38.5 22.0068V29H35.75V22.0068H38.5ZM34.25 22.0068V29H31.5V22.0068H34.25ZM25.5009 20.5068L35.0001 13.502L44.4988 20.5068H25.5009ZM25.5 32.25C25.5 31.2835 26.2835 30.5 27.25 30.5H42.75C43.7165 30.5 44.5 31.2835 44.5 32.25V33H25.5V32.25Z",
  fill: "#212121"
});

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.075034ba.svg";
export { ForwardRef as ReactComponent };